<template>
  <div class="well-top-wrap ocr-tabs-bar">
    <div class="tabs-data">
      <div class="tabs-toggle">
        <v-tabs
          :model-value="modelValue"
          color="primary"
          @update:model-value="$emit('update:modelValue', $event)"
        >
          <slot />
        </v-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OcrTabs",
  props: {
    modelValue: { type: [String, Number], default: null },
  },
  emits: ["update:modelValue"],
};
</script>
